export enum TRANSMISSION_CREATION_OPTION {
  UPDATE_TRANSMISSION_INFORMATION = 'updateTransmissionInformation',
}
